
import React from 'react';
import { motion } from 'framer-motion';

const techStack = [
  { category: 'Languages', items: ['TypeScript', 'Rust', 'Go', 'Python', 'C++'] },
  { category: 'Frontend', items: ['React', 'Next.js', 'Framer Motion', 'Tailwind CSS'] },
  { category: 'Backend', items: ['Node.js', 'FastAPI', 'PostgreSQL', 'Redis'] },
  { category: 'Intelligence', items: ['OpenAI SDK', 'TensorFlow', 'PyTorch', 'Vector DBs'] },
  { category: 'DevOps', items: ['Docker', 'Kubernetes', 'Nginx', 'GitHub Actions'] },
  { category: 'OS', items: ['Debian', 'Ubuntu Server', 'Arch', 'Alpine'] },
];

const Technology: React.FC = () => {
  return (
    <section id="technology" className="py-32 bg-[#000000] relative">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-20"
        >
          <h2 className="text-zinc-600 text-[11px] uppercase tracking-[0.5em] font-bold mb-6">Expertise</h2>
          <h3 className="text-4xl md:text-5xl font-bold tracking-tight">Our Stack.</h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1">
          {techStack.map((stack, i) => (
            <motion.div
              key={stack.category}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="p-10 border border-white/5 flex flex-col gap-6 group hover:bg-white/[0.02] transition-colors"
            >
              <span className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 font-bold">{stack.category}</span>
              <div className="flex flex-wrap gap-3">
                {stack.items.map((item) => (
                  <span 
                    key={item} 
                    className="text-lg font-bold tracking-tight text-white group-hover:text-violet-400 transition-colors"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technology;
